import { render } from "./BarButtonGeneric.vue?vue&type=template&id=d17fed54"
import script from "./BarButtonGeneric.vue?vue&type=script&lang=js"
export * from "./BarButtonGeneric.vue?vue&type=script&lang=js"

import exportComponent from "/Users/romain/Developer/vue-file-toolbar-menu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__